import { createApp } from 'vue'
import { createPinia } from 'pinia';
import App from './App.vue'
import { router } from './router'
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import axios from 'axios';
import VueAxios from 'vue-axios';
import vue3GoogleLogin from 'vue3-google-login';
import { sessionStore } from './stores/Session';




createApp(App)
    .use(router)
    .use(createPinia())
    .use(VueAxios, axios)
    .use(vue3GoogleLogin, {
        clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
    })
    .mount('#app');